import React from 'react';
import ecbbClientes from 'assets/img/2026/ecbb_clientes.png';
import ecbbFinanceiro from 'assets/img/2026/ecbb_financeiro.png';
import ecbbAsg from 'assets/img/2026/ecbb_asg.png';
import ecbbTransformacao from 'assets/img/2026/ecbb_transformacao.png';
import ecbbCultura from 'assets/img/2026/ecbb_cultura.png';
import simplificacao from 'assets/img/2026/simplificacao.png';
import negocios from 'assets/img/2026/negocios.png';
import sustentacao from 'assets/img/2026/sustentacao.png';
import todos from 'assets/img/2026/todos_conex.png';
import './HeroIniciativas.scss';

interface HeroIniciativasProps {
  categoriaSelecionada: string;
  onCategoriaChange: (categoria: string) => void;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
}

export const HeroIniciativas: React.FC<HeroIniciativasProps> = ({
  categoriaSelecionada,
  onCategoriaChange,
  title,
  subtitle
}) => {
  const categorias = [
    { id: 'ECBB_CLIENTES', nome: 'ECBB - Clientes', imagem: ecbbClientes },
    { id: 'ECBB_FINANCEIRO', nome: 'ECBB - Financeira', imagem: ecbbFinanceiro },
    { id: 'ECBB_ASG', nome: 'ECBB - ASG', imagem: ecbbAsg },
    { id: 'ECBB_TDIGITAL', nome: 'ECBB - Transformação Digital e Processos', imagem: ecbbTransformacao },
    { id: 'ECBB_CULTURA_PESSOAS', nome: 'ECBB - Pessoas e Cultura', imagem: ecbbCultura },
    { id: 'SIMPLIFIQUE', nome: 'Simplificação e Eficiência', imagem: simplificacao },
    { id: 'CONEXAO', nome: 'Negócios e Atendimento', imagem: negocios },
    { id: 'PILAR', nome: 'Pilar de Sustentação', imagem: sustentacao },
    { id: 'todos', nome: 'todas', imagem: todos },
  ];

  return (
    <div className="hero-iniciativas" role="banner">
      <div className="hero-iniciativas__content">
        <h1 className="hero-iniciativas__title" tabIndex={0}>
          {title ?? 'Iniciativas do Prêmio BB 2026'}
        </h1>
        <p className="hero-iniciativas__subtitle" tabIndex={0}>
          {subtitle ?? (
            <>
              Explore, elogie e favorite as iniciativas <br></br> que estão transformando o BB
            </>
          )}
        </p>

        <div className="hero-iniciativas__categorias">
          <label className="hero-iniciativas__label">Selecione a categoria:</label>
          <div className="hero-iniciativas__categorias-grid">
            {categorias.map((categoria) => (
              <button
                key={categoria.id}
                className={`hero-iniciativas__categoria-btn ${
                  categoriaSelecionada === categoria.id ? 'active' : ''
                }`}
                onClick={() => onCategoriaChange(categoria.id)}
                aria-label={`Filtrar por ${categoria.nome}`}
                title={categoria.nome}
              >
                <img src={categoria.imagem} alt="" aria-hidden="true" />
                <span className="hero-iniciativas__categoria-nome">{categoria.nome}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
